export class MetConfig {
  environment: any;
}
